// extracted by mini-css-extract-plugin
module.exports = {"summary":"MSummary_summary__3QAr6"};